import { render, staticRenderFns } from "./product-detail-floor-2.vue?vue&type=template&id=22049dee&scoped=true"
import script from "./product-detail-floor-2.vue?vue&type=script&lang=js"
export * from "./product-detail-floor-2.vue?vue&type=script&lang=js"
import style0 from "./product-detail-floor-2.vue?vue&type=style&index=0&id=22049dee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22049dee",
  null
  
)

export default component.exports